import getAxios from '@/utils/axios-request'

export async function getDeveloperInfo(developerId) {
  const axios = await getAxios('marketplace')
  return axios({
    url: `/rpc/developer_accessible_developer_info?developer_profile_id=${developerId}`,
    method: 'get'
  })
}

export async function searchDeveloper(cancelToken, limit, offset = 0, filter = {}) {
  const axios = await getAxios('marketplace')
  let query = ''
  if (filter.industryName && filter.industryName !== 'All') {
    query += `&industry=eq.${encodeURIComponent(filter.industryName)}`
  }
  if (filter.searchKeyword) {
    query += `&search_text=${filter.searchKeyword}`
  }
  return axios({
    url: `/rpc/developer_accessible_developer_cards?${limit === 0 ? '' : `&limit=${limit}`}&offset=${offset}${query === '' ? '' : query}`,
    method: 'get',
    headers: {
      'Prefer': 'count=exact'
    },
    cancelToken: cancelToken
  })
}
